const ProccessStatus = {
    1: "Başarılı",
    99: "Çalışıyor",
    '-1': "Hata",
    98: "Beklemede",
}

export default ProccessStatus;